import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { LITTLE_HIBBA_TEMPLATE } from './emailTemplates';

const CampaignEditor = ({ subject, setSubject, body, setBody }) => {
    
    const handleLoadTemplate = () => {
        if (window.confirm('This will overwrite your current content. Do you want to load the template?')) {
            setBody(LITTLE_HIBBA_TEMPLATE);
        }
    };

    const quillModules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
        ],
    };

    return (
        <div className="card shadow-sm mb-4 h-100">
            <div className="card-body d-flex flex-column">
                {/* Subject Input */}
                <div className="mb-3">
                    <label className="form-label fw-bold text-secondary">Campaign Subject</label>
                    <input
                        type="text"
                        className="form-control form-control-lg border-2"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        placeholder="e.g., The Magic of Reading Starts Here 🇬🇧"
                    />
                </div>

                {/* Template Button */}
                <div className="d-flex justify-content-end mb-2">
                    <button 
                        type="button" 
                        className="btn btn-sm btn-outline-warning d-flex align-items-center gap-1"
                        onClick={handleLoadTemplate}
                    >
                        <SparklesIcon style={{width:'16px'}} /> Load "Little Hibba" Template
                    </button>
                </div>

                {/* Editor */}
                <div className="flex-grow-1 d-flex flex-column">
                    <label className="form-label fw-bold text-secondary">Email Content</label>
                    <div className="flex-grow-1" style={{ minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
                        <ReactQuill
                            theme="snow"
                            value={body}
                            onChange={setBody}
                            modules={quillModules}
                            style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                            className="h-100"
                        />
                    </div>
                </div>
            </div>
            {/* ReactQuill CSS override for flex height */}
            <style>{`
                .ql-container { flex: 1; display: flex; flex-direction: column; }
                .ql-editor { flex: 1; overflow-y: auto; }
            `}</style>
        </div>
    );
};

export default CampaignEditor;